import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=7493b8af&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7493b8af')) {
      api.createRecord('7493b8af', component.options)
    } else {
      api.reload('7493b8af', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=7493b8af&", function () {
      api.rerender('7493b8af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/natural_entities/Form.vue"
export default component.exports